import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { SCORE_TYPE } from '../../../common/header/companyInfo/constant'
import { selectLoading } from '../../store/slice'
import classes from './index.module.scss'
import { LastUpdate } from './LastUpdate'
import { ScoreItem } from './ScoreItem'

export const Score = () => {
  const isLoading = useSelector(selectLoading('score'))

  const renderScoreList = () => {
    return (
      <Element className={classes.scoreList}>
        {Object.keys(SCORE_TYPE).map((key) => (
          <ScoreItem key={key} scoreType={key} />
        ))}
      </Element>
    )
  }

  return (
    <Element className={classes.container}>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {renderScoreList()}
          <LastUpdate />
        </>
      )}
    </Element>
  )
}
